import { render, staticRenderFns } from "./product-add.vue?vue&type=template&id=3f2bc44d&scoped=true&"
import script from "./product-add.vue?vue&type=script&lang=js&"
export * from "./product-add.vue?vue&type=script&lang=js&"
import style0 from "./product-add.vue?vue&type=style&index=0&id=3f2bc44d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2bc44d",
  null
  
)

export default component.exports